import React from 'react';

const SectionHeader = ({ children }) => (
    <div className="section-header">{children}</div>
);

export default SectionHeader;
